import moment from "moment-timezone";
import {
    CHO_PHAT_HANH,
    CHO_XU_LY_HUY,
    CHUYEN_KHOAN,
    CONG_NO,
    DA_PHAT_HANH, DUNG_PHAT_HANH, HUY_HOA_DON,
    IMPORT,
    QUET_THE, THAT_BAI, CITIME
} from "@/common/define";
import {formatVND} from "@/core/filters";

export class TaxInvoiceModel {
    constructor(model) {
        this.id = model.id;
        this.amountId = model.amount_id;
        this.codeTaxInvoice = model.tax_code;
        this.codeInvoice = model.type == 5 ? '' : model.amount_id;
        this.releaseCode = model.release_code;
        this.type = model.type;
        this.status = model.status;
        this.typeString = this.getTypeString(model.type)
        this.name = model.user_name;
        this.phone = model.phone;
        this.amount = this.formatMoney(model.amount);
        this.createdAt = this.formatDateTime(model.created_at)
        this.releaseDate = this.formatDate(model.release_time);
        this.statusString = this.getStatusString(model.status);
        this.bgStatus = this.getBgStatus(model.status);
        this.centerName = model?.center?.name ?? '';
        this.address = model.address ?? ''
        this.showButton = this.checkShowButton(model.status, model.type)
        this.code_gt = model?.log_amount?.contract?.created_user
            ? model?.log_amount?.contract?.created_user + 100000
            : '';
        this.leaderId = model?.log_amount?.contract?.leader_code;
    }
    formatDate(date) {
        if (date) {
            return moment(date).format('DD-MM-YYYY');
        }
        return ''
    }

    checkShowButton(status, type) {
        if (status === DA_PHAT_HANH && type === IMPORT || status === CHO_XU_LY_HUY) {
            return 1
        }
        if (status === CHO_PHAT_HANH) {
            return 2
        }
    }

    formatMoney(value) {
        if (value) {
            return formatVND(value)
        }
        return ''
    }

    getTypeString(type) {
        switch (type) {
            case CHUYEN_KHOAN:
                return 'Chuyển khoản'
            case QUET_THE:
                return 'Quẹt thẻ'
            case CONG_NO:
                return 'Công nợ'
            case IMPORT:
                return 'Import'
            case CITIME:
                return 'Citime'
        }
    }

    formatDateTime(dateTime) {
        if (dateTime) {
            return moment(dateTime).format('DD-MM-YYYY HH:mm:ss');
        }
        return ''
    }

    getStatusString(status) {
        switch (status) {
            case DA_PHAT_HANH:
                return 'Đã phát hành'
            case CHO_PHAT_HANH:
                return 'Chờ phát hành'
            case CHO_XU_LY_HUY:
                return 'Chờ xử lý hủy'
            case HUY_HOA_DON:
                return 'Hủy hóa đơn'
            case THAT_BAI:
                return 'Thất bại'
            case DUNG_PHAT_HANH:
                return 'Dừng phát hành'
            default:
                return ''
        }
    }

    getBgStatus(status) {
        switch (status) {
            case DA_PHAT_HANH:
                return 'bg-success'
            case DUNG_PHAT_HANH:
                return 'bg-cancel'
            case CHO_PHAT_HANH:
                return 'bg-waiting'
            case CHO_XU_LY_HUY:
                return 'bg-blue-500'
            case HUY_HOA_DON:
                return 'bg-cancel'
            case THAT_BAI:
                return 'bg-fail'
            default:
                return ''
        }
    }
}
